import React, { useState } from 'react';

const useQueryFilterParams = props => {
  const [query, setQuery] = useState({
    page: props?.page || 1,
    per_page: props?.per_page || 10,
    filterrific: {}
  });

  const setFilters = (event) => {
    const { type } = event

    let _query = { ...query }

    if (type == 'pagination') {
      _query = onPagination(event, _query)
    }

    if(type == 'filter'){
      _query = onFilter(event, _query)
    }

    if(type == 'sort'){
      _query = onSort(event, _query)
    }

    setQuery({ ..._query })
  }

  const onPagination = (event, _query) => {
    if(_query.page !== event.page) {
      _query.page = event.page
    }

    if(_query.per_page !== event.rows) {
      _query.per_page = event.rows
    }

    return _query;
  }

  const onFilter = (event, _query) => {
    _query.filterrific = { ..._query.filterrific, ...event.filters }

    // se comparan las keys para saber cuales no están en el event.filters debido al filtro de columnas visibles
    // y asi limpiar los valores de las columnas ocultas
    let diffKeyParams = _.difference(_.keys(_query.filterrific), _.keys(event.filters))
    _.each(diffKeyParams, (key) => { _query.filterrific[key] = '' })

    return _query
  }

  const onSort = (event, _query) => {

    _query.filterrific = { ... _query.filterrific, sorted_by: event?.sort?.sorted_by}

    return _query
  }

  // Puedes simplemente cambiar el nombre aquí y en la declaración anterior:
  // Por ejemplo, cambiar "setRequestParams" a "setFilterrific".
  // Puedes agregarle alias creando un objeto y retornando las referencias deseadas bajo distintos nombres:
  return [query, setFilters, {
    queryFilterParams: query,
    setQueryFilterParams: setFilters
  }];
}

export default useQueryFilterParams;
